import React from "react";
import {Divider, Paper} from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicMenu from "./MemuComponents/BasicMenu";
import IconMenu from "./MemuComponents/IconMenu";
import IconMenuDense from "./MemuComponents/IconMenuDense";
import IconMenuDisabled from "./MemuComponents/IconMenuDisabled";
import MAxHeightMenu from "./MemuComponents/MAxHeightMenu";
import MenuWithTransition from "./MemuComponents/MenuWithTransition";
import SelectedMenu from "./MemuComponents/SelectedMenu";

const MenuPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Menu"}
        description={"Menus display a list of choices on temporary surfaces."}
      />
      <Divider light />
      <BasicMenu />
        <MenuWithTransition />
        <SelectedMenu/>
        <IconMenu />
        <IconMenuDense />
        <IconMenuDisabled />
        <MAxHeightMenu />
    </Paper>
  );
};

export default MenuPage;
